import styled from "styled-components";

export const Header = styled.header`
  h1 {
    color: var(--dark-blue);
    font-weight: 700;
  }
`;
